import { useMemo, type ReactNode } from 'react';
import { CssBaseline, useMediaQuery } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { lightTheme, darkTheme } from './catalisTheme';
import { DateLocalizationProvider } from './LocalizationProviderConfig';

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  const theme = useMemo(() => (prefersDark ? darkTheme : lightTheme), [prefersDark]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <DateLocalizationProvider>{children}</DateLocalizationProvider>
    </MuiThemeProvider>
  );
};
